export const BRAZE_NEW_HOME_ALERT_CARD_TYPE = 'newHomeAlert';
export const BRAZE_NEW_HOME_ALERT_CARD_TARGET = 'consumer';
export const BRAZE_NEW_HOME_ALERTS_STORAGE_KEY = '__pg--new-home-alerts';
export const BREAKOUT_PRICE_K = 1000;
export const BREAKOUT_PRICE_M = 1000000;
